import LineIcon from "../../assets/images/LineIcon";
import ProfileImage2 from "../../assets/images/profile2.svg";
import Button from "../common/cta/Button";
import SearchBar from "../common/SearchBar";
import NotificationIcon2 from "../../assets/images/NotificationIcon2";
import { readFromLocalStorage } from "../../utils/DataEncryption";
import { RoleItem } from "./MobileResponsiveHeader";
import { useTranslation } from "react-i18next";
import NumberOfBranchesIcon from "../../assets/images/NumberOfBranchesIcon";
import DealerShipNameIcon from "../../assets/images/DealerShipNameIcon";

const HeaderWeb = ({
  handleLogout,
  setLogout,
  isLogout,
}: {
  handleLogout: () => void;
  setLogout: (val: boolean) => void;
  isLogout: boolean;
}) => {
  const { t } = useTranslation();

  const storedBaseRolesParsed: RoleItem[] = JSON.parse(
    readFromLocalStorage("baseRoles") || "[]"
  );

  const application = JSON.parse(readFromLocalStorage("applications") || "[]");

  const hideLogoutButton =
    Array.isArray(application) &&
    application.some((app: string) =>
      ["salesmate-app", "salesmate-asa-app"].includes(app)
    );

  const userName = readFromLocalStorage("userName") ?? "Dealer";
  const dealerId = readFromLocalStorage("dealerId") ?? "";
  const dealershipName = readFromLocalStorage("dealershipName") ?? "";
  const branches: string[] = JSON.parse(
    readFromLocalStorage("branches") || "[]"
  );

  return (
    <div className="border-b-white shadow-lg">
      <div className="bg-white text-black flex items-center h-24 px-6 gap-6">
        {/* LEFT : User Info */}
        <div className="flex-1 min-w-0">
          <div className="flex flex-col gap-0.5 truncate">
            {/* Welcome + Name */}
            <div className="flex items-center truncate title1">
              <div>
              <span>{t("Welcome")}, </span>
              <span className="text-primary">{userName}</span>
              </div>
            </div>

            {/* Roles */}
            {storedBaseRolesParsed.length > 0 && (
              <div className="text-popUpTitleColor headerRoleDetails truncate">
                {storedBaseRolesParsed
                  .map((roleItem) => roleItem?.role?.name ?? "Dealer")
                  .join(", ")}
              </div>
            )}

            {/* Dealer Details */}
            <div className="  flex flex-wrap items-center gap-3">
              <div className="flex items-center border border-sideMenubackground bg-sideMenubackground p-2  rounded-lg ">
                <DealerShipNameIcon />
                <span className="headerDealerDetails pl-1">{dealershipName}</span>
              </div>

              <span className="headerDealerDetails">Dealer ID : {dealerId}</span>
              <div className="flex items-center">
                <NumberOfBranchesIcon />
                <span className="headerDealerDetails pl-1">
                  {branches.length} branches
                </span>
              </div>
            </div>
          </div>
        </div>

        {/* CENTER : Search Bar */}
        <div className="hidden md:flex flex-[2] min-w-0 max-w-[25vw]">
          <SearchBar from="Header" />
        </div>

        {/* RIGHT : Icons */}
        <div className="flex items-center gap-6 flex-shrink-0">
          <div className="h-12 w-12 rounded-xl bg-sideMenubackground flex items-center justify-center">
            <NotificationIcon2 />
          </div>

          {!hideLogoutButton && (
            <>
              <LineIcon />
              <button
                type="button"
                onClick={() => setLogout(!isLogout)}
                className="flex"
              >
                <img src={ProfileImage2} alt="Profile" className="w-12 h-12" />
              </button>
            </>
          )}
        </div>

        {/* LOGOUT POPUP */}
        {isLogout && (
          <div className="z-10 fixed top-[90px] right-5 bg-white shadow-2xl rounded-lg w-[300px] h-[300px] p-4">
            <Button
              handleClick={handleLogout}
              buttonText={t("Logout")}
              className="focus:ring-4 focus:ring-gray-300 bg-primary ml-14 mt-5 text-white px-16 py-4 rounded-md transition duration-300 hover:bg-whiteColor hover:text-black hover:border-gray500 hover:border"
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default HeaderWeb;
